import { AuthAction } from './AuthModel'

export function authFetchAdd(): AuthAction {
  return { type: 'AUTH_FETCH_ADD' }
}

export function authFetchSub(): AuthAction {
  return { type: 'AUTH_FETCH_SUB' }
}

export const setUserId = (userId: number): AuthAction => {
  return { type: 'SET_USER_ID', userId }
}

export const setIsUserIdLoading = (isUserIdLoading: boolean): AuthAction => {
  return { type: 'SET_IS_USER_ID_LOADING', isUserIdLoading }
}

export const resetUserId = (): AuthAction => {
  return { type: 'RESET_USER_ID' }
}
